// src/services/authService.ts
const BASE_URL = process.env.REACT_APP_API_URL;

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export async function loginUser(
  username: string,
  password: string
): Promise<AuthTokens> {
  const response = await fetch(`${BASE_URL}/api/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error("Invalid username or password");
  }

  const data: AuthTokens = await response.json();
  return data;
}

/**
 * Use refresh token to obtain new tokens.
 * Adjust the endpoint and payload based on your backend's actual API contract.
 */
export async function refreshTokens(refreshToken: string): Promise<AuthTokens> {
  const response = await fetch(`${BASE_URL}/api/auth/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    throw new Error("Refresh token is invalid or expired");
  }

  const data: AuthTokens = await response.json();
  return data;
}

export async function revokeToken(token: string): Promise<void> {
  console.log("token>>>>>>",token)
  const response = await fetch(`${BASE_URL}/api/auth/revoke`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  if (!response.ok) {
    throw new Error("Token revocation failed");
  }
}